/* ── CANDELINAS CUSTOM — AUTUMN landing ──────────────────────────────────
   One job: add to cart from a card or the bundle band, and confirm it.

   Unlike the ARCHIVE II page there is no local "box" here — every press
   writes straight to the cart, so nothing is lost if the shopper opens a
   product page and comes back. The added state is therefore only a visual
   confirmation and is deliberately NOT restored on reload: the cart is the
   truth, and a button claiming "added" for a line the shopper has since
   removed would be a lie.
   ──────────────────────────────────────────────────────────────────────── */
(function () {
  var root = document;

  function label(btn) {
    return btn.getAttribute('data-au-label-added') || 'ADDED';
  }

  function flash(btn) {
    if (btn.dataset.auDone === '1') return;
    btn.dataset.auDone = '1';
    btn.textContent = label(btn);
    btn.classList.add('is-added');
  }

  function bump(count) {
    // ONLY `cart:updated`, which refreshes the header count in place.
    //
    // The theme also listens for `apps:product-added-to-cart` and answers it by
    // opening the cart drawer. That drawer's scroll-lock does not preserve the
    // page offset, so every add threw the shopper from wherever they were back
    // to the top of the page — measured at 1153px -> 0 on a card halfway down.
    // On a five-card browse-and-add page that is hostile: you add one scent and
    // have to scroll back down for the next. The button already confirms with
    // its own ADDED state, so the drawer earns nothing here.
    root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { count: count } }));
  }

  // Adds are SERIALISED. Two /cart/add.js calls in flight at once race on the
  // same cart and one silently loses: clicking two cards quickly added two
  // buttons' worth of "added" state but left a single line in the cart.
  // Disabling the one button is not enough — the collision is between cards.
  var queue = Promise.resolve();

  function add(btn, id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { flash(btn); bump(cart.item_count); })
      .catch(function () {
        // Leave the label untouched so it never claims an add that did not
        // happen, and give the control back.
        btn.disabled = false;
      })
      .then(function () {
        if (btn.dataset.auDone === '1') btn.disabled = false;
      });
  }

  /* ── keeping the shopper's place ───────────────────────────────────────
     The theme's cart drawer locks the page by setting, on <body>:

         position: fixed;  top: 0;

     A scroll-lock has to park the body at `top: -<current scrollY>px` and put
     the offset back when it releases. Setting it to 0 throws the offset away,
     so opening the drawer teleports the page to the top — measured here at
     1153px -> 0 from a card halfway down the grid. On a page whose whole job
     is adding five scents in a row, that means scrolling back down after every
     single add.

     This is the theme's own behaviour on every add-to-cart, not something this
     page introduced; the fix is kept scoped to this page rather than patched
     site-wide. We track the real offset, hold the body at it while the drawer
     is open, and restore it on close.
     ──────────────────────────────────────────────────────────────────────── */
  var lastY = window.scrollY || 0;
  var locked = false;

  // The offset is taken at the moment of the gesture, in the capture phase,
  // before any handler can open the drawer. Reading it later is too late:
  // applying position:fixed makes the browser scroll to 0 and fire a scroll
  // event, and that event beats the MutationObserver — so a tracker fed only
  // by scroll events records 0 and faithfully restores the top of the page.
  document.addEventListener('pointerdown', function () {
    if (!locked) lastY = window.scrollY;
  }, true);

  window.addEventListener('scroll', function () {
    if (!locked) lastY = window.scrollY;
  }, { passive: true });

  function syncLock() {
    var open = document.body.classList.contains('cand-cart-open');
    if (open) {
      locked = true;
      // The theme writes its own inline styles on <body> when it locks, and
      // the order of those writes against this observer is not guaranteed —
      // in testing it clobbered the offset on roughly half the opens. So the
      // value is re-asserted whenever anything touches the attribute, and set
      // as !important so a stylesheet rule cannot outrank it.
      var want = (-lastY) + 'px';
      if (document.body.style.top !== want) {
        document.body.style.setProperty('top', want, 'important');
      }
    } else if (locked) {
      locked = false;
      document.body.style.removeProperty('top');
      window.scrollTo(0, lastY);
    }
  }

  new MutationObserver(syncLock).observe(document.body, {
    attributes: true, attributeFilter: ['class', 'style']
  });

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-au-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = Number(btn.getAttribute('data-au-add'));
    if (!id) return;

    btn.disabled = true;
    queue = queue.then(function () { return add(btn, id); });
  });
})();
